import React from "react";
import OfferingDetailCard from "./Components/OfferingDetailCard.js";
import { useNavigate } from "react-router-dom";

const OfferingInitialSection = () => {
  const navigate = useNavigate();

  const offersList = [
    {
      title: "DATA and AI STRATEGY",
      description:
        "We develop AI strategies that guide organizations through digital and AI transformations, ensuring effective implementation and growth. Our approach aligns AI strategy with overarching business goals, identifying high-value initiatives and creating operational roadmaps to drive development, execution, and adoption. We design, build, and implement AI platforms to establish a solid and secure foundation for the technical delivery of artificial intelligence. ",
      imageURL: "/images/offer-image-1.jpg",
    },
    {
      title: "GENERATIVE AI",
      description:
        "We create Generative AI agents and tools designed to optimize and support intricate business workflows. In collaboration with our clients, we unlock the vast potential of Generative AI to drive positive impact and transformative value. This includes improving customer and user experiences, boosting productivity through workflow automation, and uncovering new business opportunities—ultimately delivering long-term value.",
      imageURL: "/images/offer-image-2.jpeg",
    },
    {
      title: "Ai Center of Excellence",
      description:
        "Empower your organization with AI Global Capability Centers (GCC) and Centers of Excellence (CoE). We help you build, scale, and optimize AI-driven solutions with dedicated teams, cutting-edge infrastructure, and industry best practices. From strategy to execution, we accelerate your AI journey while ensuring innovation, efficiency, and compliance.",
      imageURL: "/images/case-studies/3/case-image-0.jpeg",
    },
    {
      title: "ADVANCED ANALYTICS AND MACHINE LEARNING",
      description:
        "We develop AI strategies that guide organizations through digital and AI transformations, ensuring effective implementation and growth. Our approach aligns AI strategy with overarching business goals, identifying high-value initiatives and creating operational roadmaps to drive development, execution, and adoption. We design, build, and implement AI platforms to establish a solid and secure foundation for the technical delivery of artificial intelligence. ",
      imageURL: "/images/offer-image-4.jpeg",
    },
  ];

  return (
    <section className="relative mb-12">
      <div className="flex flex-col md:p-4 min-h-screen">
        <div className="text-white flex-1 flex flex-col">
          <main className="flex-1 flex flex-col items-center pt-[16%] md:pt-[6%] mx-[6%] md:mx-[22%] z-10 pb-[6%]">
            <h1 className="text-4xl md:text-7xl font-extrabold text-center text-white leading-[140%] tracking-[0] mb-6">
              AI isn’t just what we build, it's how we drive impact
            </h1>

            <p className="text-center text-lg md:text-xl font-medium leading-[140%] tracking-[0] text-white mb-12 md:px-[12%]">
              We craft scalable AI solutions that transform businesses, empower
              decisions, and unlock new possibilities
            </p>
          </main>
          <div class="justify-center grid md:grid-cols-1 gap-y-6 md:gap-y-40 px-4 md:px-20 pb-12">
            {offersList.map((offers, index) => {
              return (
                <OfferingDetailCard
                  tag={offers.tag}
                  title={offers.title}
                  left={index % 2 === 0}
                  imageUrl={offers.imageURL}
                  description={offers.description}
                  onClick={() => navigate("/case-studies")}
                />
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OfferingInitialSection;
